import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";

import "animate.css/animate.min.css";
import ScrollAnimation from "react-animate-on-scroll";
import { useTranslation } from "react-i18next";

const Cibi = () => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="css_team">
        <Container sx={{ paddingBottom: "150px", paddingTop: "150px" }}>
          <Box className={classes.product__inner}>
            <Box sx={{ textAlign: "center" }} className="title">
              CI & BI
            </Box>
            <Typography color="gray" sx={{ textAlign: "center" }}>
              {t("cibi")}
            </Typography>
            <Grid
              container
              spacing={5}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "40px",
                pb: 20,
                pt: 10,
              }}
            >
              <Grid
                className={classes.box}
                item
                md={7}
                sm={12}
                sx={{ marginLeft: { sm: "35px", md: 0 } }}
              >
                <ScrollAnimation animateIn="fadeIn" duration={2}>
                  <Typography
                    dangerouslySetInnerHTML={{ __html: t("cibi_exp") }}
                  />
                </ScrollAnimation>
              </Grid>
              <Grid
                item
                md={5}
                sm={12}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box sx={{ width: "150px", pr: 3 }}>
                  <img
                    src="img/ci_text.png"
                    alt="ceo"
                    width="150"
                    height="100"
                    style={{}}
                  />
                  <img
                    src="img/ci_symbol.png"
                    alt="ceo"
                    width="150"
                    height="100"
                  />
                </Box>
                <img src="img/logo2.png" alt="ceo" width="170" />
              </Grid>
            </Grid>
          </Box>
        </Container>
      </div>
    </>
  );
};

export default Cibi;

const useStyles = makeStyles({
  box: {
    width: "50%",
    color: "black",
    borderRadius: "20px",
    padding: "30px",
    backgroundColor: "white",
    position: "relative",
    top: "+20px",
    boxShadow:
      "rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px",
  },
});
